import {isIOS} from "../../../../utility/windowUtil";
import {PaymentMethodButton, paymentMethodButtons} from "../sections/F007PaymentForm/paymentMethodButtons";
import {
    DonationRhythm,
    DonationType,
    DonatorType,
    FormDataInput,
    PaymentMethod,
    SalutationType,
    SponsorshipType
} from "../types";
import {ImageToggleButton} from "../../../fundamentals/CCOImageToggleButton";
import {TextToggleButton} from "../../../fundamentals/CCOTextToggleButton";

export const salutationOptions = [
    { label: "Herr", value: SalutationType.Male },
    { label: "Frau", value: SalutationType.Female },
    { label: "Neutrale Anrede", value: SalutationType.Divers },
    { label: "Familie", value: SalutationType.Family },
];

export const donatorTypeOptions = [
    { label: "Privatperson", value: DonatorType.PrivatePerson },
    { label: "Firma", value: DonatorType.Company },
];

export const sponsorshipTypeButtons = [
    {
        value: SponsorshipType.ChildSponsorship,
        src: "/child-sponsor.svg",
        alt: "Kindpate werden",
        direction: "column",
        size: "lg",
        dataCypress: "sponsorshipType" + SponsorshipType.ChildSponsorship,
    } as ImageToggleButton,
    {
        value: SponsorshipType.VillageSponsorshipInGermany,
        src: "/village-sponsor.svg",
        alt: "Dorfpate in Deutschland werden",
        direction: "column",
        size: "lg",
        dataCypress: "sponsorshipType" + SponsorshipType.VillageSponsorshipInGermany,
    } as ImageToggleButton,
    {
        value: SponsorshipType.VillageSponsorshipAbroad,
        src: "/abroad-sponsor.svg",
        alt: "Dorfpate im Ausland werden",
        direction: "column",
        size: "lg",
        dataCypress: "sponsorshipType" + SponsorshipType.VillageSponsorshipAbroad,
    } as ImageToggleButton
] as Array<ImageToggleButton>

export const donationTypeButtons: ImageToggleButton[] = [
    {
        value: DonationType.Donation,
        src: "/donation.svg",
        alt: "Spenden",
        direction: "column",
        dataCypress: "donationType" + DonationType.Donation,
    },
    {
        value: DonationType.Sponsorship,
        src: "/sponsorship.svg",
        alt: "Patenschaft",
        direction: "column",
        dataCypress: "donationType" + DonationType.Sponsorship,
    },
];

export const donationRhythmButtons = [
    {
        value: DonationRhythm.Unique,
        src: "/onetime.svg",
        alt: "Einmalig",
        direction: "column",
        dataCypress: "donationRhythm" + DonationRhythm.Unique,
    } as ImageToggleButton,
    {
        value: DonationRhythm.Monthly,
        src: "/monthly.svg",
        alt: "Monatlich",
        direction: "column",
        dataCypress: "donationRhythm" + DonationRhythm.Monthly,
    } as ImageToggleButton
] as Array<ImageToggleButton>

export const donationRhythmTextButtons: TextToggleButton[] = [
    {
        value: DonationRhythm.Unique as unknown as number,
        text: "Einmalig",
        dataCypress: "donationRhythm" + DonationRhythm.Unique,
    },
    {
        value: DonationRhythm.Monthly as unknown as number,
        text: "Monatlich",
        dataCypress: "donationRhythm" + DonationRhythm.Monthly,
    },
];

export const getOptions = (
    formInput: FormDataInput,
    donationType?: DonationType | null,
    donationRhythm?: DonationRhythm | null
): PaymentMethodButton[] =>
    paymentMethodButtons.filter((button) => {
        const paymentMethodKey = button.value as PaymentMethod;

        // --------------------------
        // Fall 1: Patenschaft oder monaltliche Spende -> nur SEPA & PayPalSubscription erlauben
        // --------------------------
        if (
            donationType === DonationType.Sponsorship ||
            donationRhythm === DonationRhythm.Monthly
        ) {
            const allowedType = button.value === PaymentMethod.SEPA || button.value === PaymentMethod.PaypalSubscription;
            const allowedBySettings = !!formInput.formSettings?.payment_method?.[paymentMethodKey];
            return allowedType && allowedBySettings;
        }

        // --------------------------
        // Fall 2: einmalige Spende -> alles außer PayPalSubscription
        // --------------------------
        if (
            (donationType === DonationType.Donation || donationType === DonationType.Product) &&
            donationRhythm === DonationRhythm.Unique
        ) {
            if (button.value === PaymentMethod.PaypalSubscription) {
                return false;
            }
            const allowedByDevice = (
                (button.value === PaymentMethod.ApplePay && isIOS()) ||
                (button.value === PaymentMethod.GooglePay && !isIOS()) ||
                (button.value !== PaymentMethod.ApplePay && button.value !== PaymentMethod.GooglePay)
            );

            const allowedBySettings = !!formInput.formSettings?.payment_method?.[paymentMethodKey];
            return allowedBySettings && allowedByDevice;
        }
        return false;
    });
